import gsap from "gsap";
import { ITransitionData } from "@barba/core";

import { lenis } from "../base/scroll";

let contact: HTMLElement;
let tl: gsap.core.Timeline;

export default function initContact() {
    const contactEl = document.querySelector<HTMLElement>(".contact");
    if (!contactEl) return;
    contact = contactEl;

    const contactInner = contact.querySelector<HTMLElement>(".contact__inner");
    const contactTrack = contact.querySelector<HTMLElement>(".contact__track");

    if (!contactInner || !contactTrack) return;

    const closeBtn = contact.querySelector(".contact__inner__close");
    closeBtn?.addEventListener("click", () => closeContact());

    contactTrack.addEventListener("click", e => {
        if (e.target === contactTrack) closeContact();
    });

    document.addEventListener("keydown", e => {
        if (e.key === "Escape") closeContact();
    });

    initTimeline(contactInner);
    initContactBtns(document);

    if (window.location.hash === "#contact") openContact();
}

const btnSelector = ".contact-popup-btn, [href$='#contact']";
export function initContactBtns(data: ITransitionData | Document) {
    const contactBtns = data instanceof Document ? data.querySelectorAll(btnSelector) : data.next.container.querySelectorAll(btnSelector);

    contactBtns.forEach(btn => {
        btn.addEventListener("click", () => openContact());
    });

    // openContact()
}

function openContact() {
    contact.setAttribute("aria-hidden", "false");
    tl.timeScale(1).play();
    lenis.stop();
}

function closeContact() {
    contact.setAttribute("aria-hidden", "true");
    tl.timeScale(1.5).reverse();
    lenis.start();
}

function initTimeline(contactInner: HTMLElement) {
    tl = gsap
        .timeline({ paused: true })
        .fromTo(
            contact,
            {
                display: "none",
            },
            {
                display: "block",
                duration: 0.1,
            }
        )
        .fromTo(
            contact,
            {
                "--overlay-opacity": 0,
            },
            {
                "--overlay-opacity": 0.5,
                duration: 0.3,
                ease: "power3.inOut",
            }
        )
        .fromTo(
            [contactInner, ".contact__inner__logo"],
            {
                y: 100 + "vh",
            },
            {
                y: 0,
                stagger: 0.03,
                ease: "power3.out",
                duration: 0.6,
            },
            "<+.1"
        );
}
